import React, { useEffect, useState, useContext } from "react";

import JobList from "../../components/jobList";
import HoneycombAlertPage from "../../components/honeycombAlertPage";
import refreshIcon from "../../img/refresh-job-icon.svg";
import AppContext from "../../context/AppProvider";
import Grid from "@mui/material/Grid";
import { Box } from "@material-ui/core";
import UserDistributionAlert from "./UserDistributionAlert";
import {  CircularProgress } from "@mui/material";
import { useCoolDownQuery } from "../../services/jobsApi";
import InformationMessage from '../../components/modals/InformationMessage';
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";

const HoneyComb = () => {
  const [reRender, setRender] = useState(false);
  const [COOLDOWN, setCOOLDOWN] = useState(null);
  const { currentJob, fetchingCurrentJob, message } = useContext(AppContext);

  const user= useSelector(selectCurrentUser);

  const [skip, setSkip] = useState(true)
  const { data, error, isLoading: cooldownIsLoading, isError, isUninitialized } = useCoolDownQuery(null, { skip });

  useEffect(() => {
    if (!user || user == {}) return;
    setSkip(false);
  }, [user]);

  useEffect(() => {
    if (data != null || data != undefined) {
      setCOOLDOWN(data);
      setSkip(true);
    }
  }, [data]);

  let isLoading = fetchingCurrentJob === true || COOLDOWN === null;
  
  let showCurrentJob = !isLoading && currentJob;
  
  let showUserDistributionAlert = !isLoading && !showCurrentJob && !user?.userDistribution;
  
  let showCooldown = !showCurrentJob && !isLoading && COOLDOWN !== 0 && COOLDOWN !== null;
  
  let showJobList = !isLoading && !showCurrentJob && !showUserDistributionAlert && !showCooldown;
  

  // Debug logs to see key values on each render
  

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ marginTop: "7em", width: { xs: "100%", sm: "90%", md: "80%", lg: "70%", xl: "60%" } }}
    >
      {isLoading && (
        
        <CircularProgress style={{ color: "#F29B1B", margin: "2em" }} />
      )}

      {showCurrentJob && (
        
        <HoneycombAlertPage />
      )}

      {showUserDistributionAlert && (
        
        <UserDistributionAlert />
      )}

      {/* {!showUserDistributionAlert && showCooldown && <Timer COOLDOWN={COOLDOWN} setShowTimer={() => setCOOLDOWN(0)} />} */}

      {showJobList && (
        
        <Box sx={{ width: { xs: "100%", sm: "90%", md: "80%", lg: "70%", xl: "60%" } }} >

          <Grid
            padding={2}
            direction="column"
            container
            spacing={0}
            alignItems="flex-start"
            justifyContent="center"
          >

            {
              (message?.title !== "" && message?.message !== "" && message?.enabled)
              &&
              <InformationMessage
                title={message?.title}
                message={message?.message}
              />
            }

            <div className="screen-jobs-title" >

              <h3>Available Jobs</h3>
              <input
                type="image"
                src={refreshIcon}
                alt="Refresh Icon"
                className="refresh-button"
                onClick={() => setRender(!reRender)}
              />
            </div>

            <JobList
              reRender={reRender}
              onMyClaim={setSkip}
            />
          </Grid>
        </Box>
      )}
    </Grid>
  );
};

export default HoneyComb;
